var _defs, _circle, _path, _polygon, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToilettesMauvaisePosition1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "r\\xE9paration_toilettes",
    "data-name": "r\\xE9paration toilettes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 529.86 520.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#fff;stroke-miterlimit:10;stroke-width:6px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "toilettes mauvaise r\xE9ponse 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.02,
    cy: 79.02,
    r: 79
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M983.76,1315.31V1198.18c-89-7.48-108.74-59-109.61-122.51h228.9v-245H1253.5v484.66Z",
    transform: "translate(-723.64 -822.72)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "362.21 255.1 362.21 19.75 379.41 49.12 379.41 254.03 362.21 255.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1052.17,1304.88c9,37.42-38.17,48-46.21,19.08,0,0-34.39-111.08-40.86-122S850.8,1310.19,821,1316.6s-81.1-21.92-74.59-110.19l4.24-175.06c14.69-67.78,93.46-41.58,142.26-39.47l202-11.59c25.41,5,34.15,36.14,12.51,48.5l-226.08,42.15s-26,120.26-16.07,125.91c17.82-17.09,106.53-76.86,122-72.87S1052.17,1304.88,1052.17,1304.88Z",
    transform: "translate(-723.64 -822.72)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToilettesMauvaisePosition1);
export default __webpack_public_path__ + "static/media/toilettes_mauvaise_position_1.94f15e15c5082efb5b7bd2615654b58f.svg";
export { ForwardRef as ReactComponent };